import { Pipe, PipeTransform } from "@angular/core";
import { AlarmMessage } from "../models/alarm-message";
import { AlarmTypePipe } from "./alarm-type.pipe";

@Pipe({
    name:"alarmMessagePipe"
})

export class AlarmMessagePipe implements PipeTransform{
    
    //transform an array of these A larmMessages
    transform(alarmMessagesDictEntry) : string{

        var alarmTypePipe = new AlarmTypePipe(); // "what's happened"
    
        console.log('pipe has: ', alarmMessagesDictEntry) //actually has a map
        console.log('+++++++++++: ', alarmMessagesDictEntry.value[0].alarm.site.name )// .value[0].alarm.site.site_name) //actually has a map

        

        //need port name, will make life easier
        return alarmMessagesDictEntry.value[0].alarm.site.name;
    }
}